import {BaseConverter} from "../../base/converters/base-converter.converter";
import {StateChangeToModel} from "../models/state-change-to.model";
import {StateChangeTo} from "../../shared/DTO/stateChangeTo";
import {Injectable} from "@angular/core";
import {CustomerPropertyConverter} from "./customer-property.converter";
import {RoleStateChangeToConverter} from "./role-state-change-to.converter";
import {TypeStateChangeToConverter} from "./type-state-change-to.converter";

@Injectable()
export class StateChangeToConverter extends BaseConverter<StateChangeToModel, StateChangeTo> {

  constructor(private customerPropertyConverter: CustomerPropertyConverter, private roleStateChangeToConverter: RoleStateChangeToConverter, private typeStateChangeToConverter: TypeStateChangeToConverter) {
    super();
  }

  convertToDto(model: StateChangeToModel): StateChangeTo {
    if (!model) {
      return;
    }
    return {
      customerProperties: this.customerPropertyConverter.convertToDtoList(model.customerProperties),
      roles: this.roleStateChangeToConverter.convertToDtoList(model.roles),
      state: model.state,
      types: this.typeStateChangeToConverter.convertToDtoList(model.types)
    };
  }

  convertToModel(dto: StateChangeTo): StateChangeToModel {
    if (!dto) {
      return;
    }
    let model: StateChangeToModel = new StateChangeToModel();
    model.types = this.typeStateChangeToConverter.convertToModelList(dto.types);
    model.state = dto.state;
    model.roles = this.roleStateChangeToConverter.convertToModelList(dto.roles);
    model.customerProperties = this.customerPropertyConverter.convertToModelList(dto.customerProperties);

    return model;
  }

}
